import React, { PropTypes } from "react";

export default function EmptyBasketView({ labels }) {
    return (
    <div className="basket-content basket-items">{labels.empty}</div>
    );
}


EmptyBasketView.propTypes = {
    labels: PropTypes.shape({
        empty: PropTypes.string,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Views/EmptyBasketView.jsx